import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['template', "forms", "aggregatePostfix", "individualPostfix"];

  initialize() {
    $(".spinner-border").hide();
    $(".remove-button-container").hide()
    if($(".prompt_card:visible").length > 1) $(".prompt_card:visible:last .remove-button-container").show();
  }
  
  generatePipelineResponse(event) {
    $(".spinner-border-sync").show();
    $(event.target).prop('disabled', true);
    console.log($(event.target))
    let id = $(event.target).data('id');
    
    Rails.ajax({
      type: 'POST',
      url: `${id}/generate_response`,
      dataType: 'json',
      success: (response) => {
        location.reload();
      }
    });
  }

  executeBatchJob(event) {
    $(".spinner-border-async").show();
    $(event.target).prop('disabled', true);
    let id = $(event.target).data('id');
    
    Rails.ajax({
      type: 'POST',
      url: `${id}/execute_batch_job`,
      dataType: 'json',
      success: (response) => {
        alert(response.message)
      }
    });
  }

  populatePostCorpusDropdown(event) {
    Rails.ajax({
      type: 'GET',
      url: `/pipelines/post_corpus_options`,
      data: $.param({"post_corpus_type": $(event.target).val()}),
      dataType: 'json',
      success: (response) => {
        $("#pipeline_default_post_corpus_id").html("")
        response.options.forEach(element => {
          $("#pipeline_default_post_corpus_id").append(new Option(element[0], element[1]))
        });
      }
    });
  }

  defaultPostCorpusSelected(event) {
    let corpus_type = $("#pipeline_default_post_corpus_type").val()
    let corpus_id = $(event.target).val()

    Rails.ajax({
      type: 'GET',
      url: `/pipelines/post_corpus_options`,
      data: $.param({"post_corpus_type": corpus_type}),
      dataType: 'json',
      success: (response) => {
        $(".prompt_card").each(function(i, elem) {
          $(elem).find('.corpus_type option:selected').attr("selected", false);
          $(elem).find(`.corpus_type option[value="${corpus_type}"]`).attr("selected", "selected");

          $(elem).find(".corpus_id").html("")
          response.options.forEach(element => {
            $(elem).find(".corpus_id").append(new Option(element[0], element[1]))
          });

          $(elem).find(`.corpus_id option[value="${corpus_id}"]`).attr("selected", "selected");
        })
      }
    });
  }

  defaultModelSelected(event) {
    let selected_model = $(event.target).val()

    $(".prompt_card").each(function(i, elem) {
      $(elem).find('.model_name option:selected').attr("selected", false);
      $(elem).find(`.model_name option[value="${selected_model}"]`).attr("selected", "selected");
    });

  }

  modelNameChanged(event) {
    let container_card = $(event.target).parents(".prompt_card")
    let field_value = $(event.target).val()
    let image_recognition_field = container_card.find(".image_recognition_field");
    let postfix_div = container_card.find(".prompt-postfix-text")

    if(field_value.includes("gpt-4")){
      image_recognition_field.removeClass("d-none")
    } else {
      image_recognition_field.addClass("d-none")
    }

    if(this.canShowPostFixFields(container_card)){
      postfix_div.removeClass("d-none")
    } else {
      postfix_div.addClass("d-none")
    }
  }

  processingTypeUpdated(event) {
    let container_card = $(event.target).parents(".prompt_card")
    let postfix_div = container_card.find(".prompt-postfix-text")
    let check_div = container_card.find(".project_labels_check")
    let post_helper_div = container_card.find(".post_helper_text")
    let corpus_fields = container_card.find(".corpus_fields")
    let posts_limit_field = container_card.find(".posts_limit_field")
    let posts_json_field = container_card.find(".posts_json_field")
    let image_recognition_field = container_card.find(".image_recognition_field")
    
    post_helper_div.removeClass("d-none")
    check_div.addClass("d-none")
    corpus_fields.removeClass("d-none")
    posts_limit_field.removeClass("d-none")
    posts_json_field.removeClass("d-none")
    image_recognition_field.removeClass("d-none")

    if($(event.target).val() == "aggregate"){
      postfix_div.html(this.aggregatePostfixTarget.innerHTML)
      post_helper_div.removeClass("d-none")
    } else if($(event.target).val() == "individual") {
      postfix_div.html(this.individualPostfixTarget.innerHTML)
    } else if($(event.target).val() == "consolidate") {
      postfix_div.html(this.aggregatePostfixTarget.innerHTML)
      check_div.removeClass("d-none")
      post_helper_div.addClass("d-none")
      corpus_fields.addClass("d-none")
      posts_limit_field.addClass("d-none")
      posts_json_field.addClass("d-none")
      image_recognition_field.addClass("d-none")
    } else {
      $(event.target).parents(".prompt_card").find(".prompt-postfix-text").html("-")
    }
  }

  canShowPostFixFields(container){
    let model_field = container.find(".model_name");
    let field_value = model_field.val();
    console.log(field_value)
    if(field_value == "gpt-4o-2024-08-06" || field_value == "gpt-4o-mini") return false;
    return true;
  }

  populatePromptPostCorpusDropdown(event) {
    let container = $(event.target).parents(".corpus_fields")
    this.resetOptionsForCorpus(container, $(event.target).val())
  }

  renderNewPromptForm(event) {
    event.preventDefault();
    let last_visible_prompt_card = $(".prompt_card:visible:last")

    let current_max_position = last_visible_prompt_card.find(".prompt_positon_field").val()
    let next_positon = Number(current_max_position) + 1

    var content = this.templateTarget.innerHTML.replace(/new_record/g, next_positon);

    last_visible_prompt_card.find(".remove-button-container").hide();
    $(this.formsTarget).append(content)
    
    last_visible_prompt_card = $(".prompt_card:visible:last")
    last_visible_prompt_card.find(".prompt_positon_field").val(next_positon)
    last_visible_prompt_card.find(".remove-button-container").show()

    last_visible_prompt_card.find(".collapse").attr("id", `fields_collapse_${next_positon}`);
    last_visible_prompt_card.find(".collapse-btn").attr("data-target", `#fields_collapse_${next_positon}`);
    last_visible_prompt_card.find(".step-count-text").text(`Step ${next_positon}`);

    //set default field values
    let default_corpus_type = $("#pipeline_default_post_corpus_type").val()
    last_visible_prompt_card.find("select.corpus_type").val(default_corpus_type)
    this.resetOptionsForCorpus(last_visible_prompt_card, default_corpus_type, $("#pipeline_default_post_corpus_id").val())
    last_visible_prompt_card.find("select.model_name").val($("#pipeline_model").val())

    $('.select2').select2({
      theme: "bootstrap4",
    });
  }

  resetOptionsForCorpus(container, value, set_value = null){
    Rails.ajax({
      type: 'GET',
      url: `/pipelines/post_corpus_options`,
      data: $.param({"post_corpus_type": value}),
      dataType: 'json',
      success: (response) => {
        container.find(".corpus_id").html("")
        response.options.forEach(element => {
          if(set_value && element[1] == set_value){
            container.find(".corpus_id").append(new Option(element[0], element[1], true, true));
          } else {
            container.find(".corpus_id").append(new Option(element[0], element[1]));
          }
          
        });
      }
    });
  }

  removePromptFields(event) {
    $(event.target).parents(".prompt_card").find(".destroy-field").val("1")

    if (window.location.pathname.includes("new")){
      $(event.target).parents(".prompt_card").remove();
    } else {
      $(event.target).parents(".prompt_card").hide();
    }
    $(event.target).parents(".prompt_card").hide();
    if($(".prompt_card:visible").length > 1) $(".prompt_card:visible:last .remove-button-container").show();
  }

  checkOption(event) {
    if($(event.target).val() == "Post"){
      $('#pipeline_label_title').prop('disabled', false);
    } else {
      $('#pipeline_label_title').prop('disabled', true);
    }
  }
}